import { render } from "./SecondReportPie.vue?vue&type=template&id=b55076d8&scoped=true"
import script from "./SecondReportPie.vue?vue&type=script&lang=js"
export * from "./SecondReportPie.vue?vue&type=script&lang=js"

import "./SecondReportPie.vue?vue&type=style&index=0&id=b55076d8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55076d8"]])

export default __exports__